import Splide from '@splidejs/splide';
import { isMobile } from './index';

const 
option = {
    start:0,
    perMove: 1,
    heightRatio: 1,
    cover: true,
    lazyLoad: true,
    mediaQuery: 'min',
    breakpoints:{
        900:{
            fixedWidth : '250px',
            fixedHeight: '250px',
            gap        : '1rem',
        },
        1400:{
            fixedWidth : '350px',
            fixedHeight: '350px',
            gap        : '1rem',
        }
    }
},
option_full = {
    start:0,
    perMove: 1,
    perPage:1,
    width:"95vw",
    arrows:false,
    lazyLoad: true,
    mediaQuery: 'min',
    breakpoints:{
        900:{
            width:"80vw",
            fixedHeight: "100vh",
            keyboard:true,
            arrows:true
        }
    }
},
body = document.querySelector("body");

document.querySelectorAll(".service-detail .splide").forEach(s => {
    const 
    name = s.dataset.name,
    currentIndex =  document.querySelector(`#carousel_${name} .state span:nth-child(1)`),
    totalIndex =  document.querySelector(`#carousel_${name} .state span:nth-child(2)`),
    full_carousel = document.querySelector(`#carousel_${name} .splide`),
    left_arrow = s.querySelector(`.splide__arrow--prev`),
    right_arrow = s.querySelector(`.splide__arrow--next`);

    const main = new Splide(s, option).mount();
    const minPhoto = Math.ceil((window.innerWidth - (window.innerWidth * 10 / 100))/350);

    if(isMobile){
        if(main.length <= 1){
            main.Components.Arrows.destroy();
        }else{
            s.classList.add("with-padding");
        }
    }else{
        if(main.length < minPhoto){
            main.Components.Arrows.destroy();
        }else{
            s.classList.add("with-padding");
        }
    }

    const second = new Splide(full_carousel, option_full).mount();
    if(isMobile && second.length <= 1 ){
        second.Components.Arrows.destroy();
    }
    if(second.length <= 1){
        second.Components.Arrows.destroy();
    }
    main.sync( second );
    
    totalIndex.innerHTML = second.length;

    main.on("click",(Slide) => {
        const id = main.root.dataset.name;
        second.go(Slide.index, true);
        second.refresh();
        handleCarousel(id);
    });
    second.on("move",(newIndex) => {
        currentIndex.innerHTML = newIndex + 1;
    });
});

document.querySelectorAll(".full-carousel").forEach(c => {
    c.addEventListener("click",(e) => {
        const tag = e.target.tagName;
        if(tag != "BUTTON" && tag!= "svg" && tag!="path"){
            body.classList.remove("hidden");
        }
    })
});

document.querySelectorAll(".full-carousel .xmark").forEach(btn => {
    btn.addEventListener("click",() => {
        const id = btn.dataset.name;
        handleCarousel(id);
    })
});

const handleCarousel = (id) => {
    id = "carousel_" + id;
    const carousel = document.getElementById(id);
    if(carousel.classList.contains("actif")){
        body.classList.remove("hidden");
    }else{
        body.classList.add("hidden");
        
    }
    carousel.classList.toggle("actif");
};
